import React from 'react'
import PropTypes from 'prop-types'

import Box from '../../Box'

const Footer = (props) => {
  const { children } = props

  return (
    <Box
      alignItems="center"
      backgroundColor="white"
      borderTop="1px solid"
      borderColor="lineColor"
      bottom="0"
      height="80px"
      padding="large"
      position="absolute"
    >
      {children}
    </Box>
  )
}

Footer.propTypes = {
  children: PropTypes.node,
}

export default Footer
